import React from 'react';
import { User, Phone, UserPlus } from 'lucide-react';

const InvoiceParticipantField = ({ guestData, onChange, isMobile }) => {
    return (
        <div className="space-y-6 animate-in fade-in slide-in-from-top-4 duration-500">
            <div className="flex items-center gap-3 mb-2 px-1">
                <div className="w-1 h-3 bg-amber-500 rounded-full" />
                <h4 className="text-[10px] font-black uppercase tracking-widest text-neutral-400 italic">Данные участника (если за другого)</h4>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                    <User className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-600" />
                    <input 
                        type="text" 
                        placeholder="ФИО участника" 
                        value={guestData.name || ''} 
                        onChange={(e) => onChange({ ...guestData, name: e.target.value })}
                        className="w-full bg-neutral-950 border border-neutral-800 text-white py-4.5 pl-12 pr-4 rounded-xl md:rounded-2xl outline-none focus:border-amber-500/50 font-bold text-xs italic transition-all"
                    />
                </div>
                <div className="relative">
                    <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-600" />
                    <input 
                        type="text" 
                        placeholder="Телефон" 
                        value={guestData.phone || ''} 
                        onChange={(e) => onChange({ ...guestData, phone: e.target.value })}
                        className="w-full bg-neutral-950 border border-neutral-800 text-white py-4.5 pl-12 pr-4 rounded-xl md:rounded-2xl outline-none focus:border-amber-500/50 font-bold text-xs italic transition-all"
                    />
                </div>
            </div>
            <p className="text-[8px] text-neutral-600 font-bold uppercase tracking-widest px-2 italic">
                * Если оставить пустым, билет будет выписан на основного контрагента
            </p>
        </div>
    );
};

export default InvoiceParticipantField;
